import { render } from "./temp_view-kv-customer-vers-children.vue?vue&type=template&id=da9482c8"
import script from "./temp_view-kv-customer-vers-children.vue?vue&type=script&setup=true&lang=js"
export * from "./temp_view-kv-customer-vers-children.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/temp_view-kv-customer-vers/temp_view-kv-customer-vers-children.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da9482c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da9482c8', __exports__)) {
    api.reload('da9482c8', __exports__)
  }
  
  module.hot.accept("./temp_view-kv-customer-vers-children.vue?vue&type=template&id=da9482c8", () => {
    api.rerender('da9482c8', render)
  })

}


export default __exports__